export default class SysObservable {

   static dealBrowserBackListener = function () {
    window.history.pushState(null, null, document.URL)
  }

  static disableBrowserBack() {
    window.history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.dealBrowserBackListener,false)
  }

  static enableBrowserBack() {
    window.removeEventListener('popstate', this.dealBrowserBackListener,false)
  }

  static unloadObservers = Array()

  static registerUnload (vueIns) {
    if (this.unloadObservers.indexOf(vueIns) < 0) {
      this.unloadObservers.push(vueIns)
    }
  }

  static unRegisterUnload (vueIns) {
    let index = this.unloadObservers.indexOf(vueIns)
    if (index > -1) {
      this.unloadObservers.splice(index, 1)
    }
  }

  static dealUnloadListener=function () {
    for (let i = 0; i < this.unloadObservers.length; i++) {
      this.unloadObservers[i].unload&&this.unloadObservers[i].unload()

    }
  }

  static dealBeforeUnloadListener=function(){
    for (let i = 0; i < this.unloadObservers.length; i++) {
      this.unloadObservers[i].beforeUnload&&this.unloadObservers[i].beforeUnload()

    }
  }

  static attachWindow(){
     window.addEventListener('beforeunload',this.dealBeforeUnloadListener)
     window.addEventListener('unload',this.dealUnloadListener)
  }

  static detachWindow(){
    window.removeEventListener('beforeunload',this.dealBeforeUnloadListener)
    window.removeEventListener('unload',this.dealUnloadListener)
  }
}

// 防抖
let timeout = null
export const debounce = (fun, time = 500) => {
  if(timeout){
    clearTimeout(timeout) // 规定时间内若定时器存在则清除
  }
  timeout = setTimeout(() => {
    console.log('触发点击')
    fun() // 调用接口
  }, time);
}
// 节流
let flag = true
export const throttle = (fun, time = 500) => {
  if(flag) {
    setTimeout(() => {
      console.log('触发点击')
      fun() // 调用接口
      flag = true // 在定时器执行后 移除if阻断
    }, time);
  }
  flag = false // 在执行一次后 if阻断定时器继续执行
}



// WEBPACK FOOTER //
// ./src/utils/sysutils.js